import callBackend from '../shared/methods/callBackend/callBackend';

const deleteTrackingRules = async (ruleId) => callBackend({
  url: `${process.env.REACT_APP_API_URL}/trackingrules/${ruleId}`,
  method: 'DELETE',
});

export default deleteTrackingRules;
